<template>
  <section id="tac-admin-cms-page" class="tac-admin-page tac-cms-page">
    <div class="page-header">
      <h1 class="page-header-title">
        <router-link :to="{name: 'admin/cms/v3/pages/list', params: {layout: 'tree'}}" class="page-header__title-link--no-highlight">
          <span class="fa fa-fw fa-th"></span> Pages
        </router-link>
        <small>Record</small>
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner">
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData" @click="save">Save</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-danger btn-sm" :disabled="fetchingData || isNewPage" @click="destroy">Delete</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData" @click="cancel">Cancel</button>
              </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || isNewPage" @click="create">New</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" title="Refresh Page" :disabled="fetchingData || isNewPage" @click="fetch"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <a target="_blank" :href="`/page/${form.slug}`" class="btn btn-default btn-sm" title="Open Live Page" :disabled="fetchingData || isNewPage"><i class="fa fa-fw fa-external-link"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            Form
          </div>
          <div class="panel-body">
            <div class="form">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-horizontal">
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-2">Slug</label>
                      <div class="col-lg-10">
                        <input type="text" class="form-control" :disabled="fetchingData || isStorageFile" v-model="form.slug"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4" v-if="isStorageDatabase">
                  <div class="form-horizontal">
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-2">Publish</label>
                      <div class="col-lg-10">
                        <select class="form-control" :disabled="fetchingData || isStorageFile" v-model="form.published">
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-horizontal">
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-2">Type</label>
                      <div class="col-lg-10">
                        <select class="form-control" disabled v-model="form.storage">
                          <option value="database">Database</option>
                          <option value="file">File</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-horizontal">
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-2">Title</label>
                      <div class="col-lg-10">
                        <input type="text" class="form-control" :disabled="fetchingData || isStorageFile" v-model="form.title"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4" v-if="isStorageDatabase">
                  <div class="form-horizontal">
                    <div class="form-group form-group-sm">
                      <label class="control-label col-lg-2">Date</label>
                      <div class="col-lg-10">
                        <input type="text" class="form-control" :value="form.datePosted | dateFormat('MM/DD/YYYY')" disabled />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4"  >
                  <div class="form-horizontal">
                    <div class="form-group form-group-sm" v-if="isStorageFile">
                      <label class="control-label col-lg-2">File</label>
                      <div class="col-lg-10">
                        <select class="form-control tac-inline" :disabled="fetchingData || isStorageFile" v-model="form.file">
                          <optgroup v-for="(fileNames, name) in list" :label="name | upperFirst" :key="name">
                            <option v-for="(fileName, fnkey) in fileNames" :value="fileName.slug" v-html="fileName.page" :key="fnkey" />
                          </optgroup>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group form-group-sm">
                <label class="control-label">Content</label>
                <textarea rows="15" class="form-control" :disabled="fetchingData"  v-model="form.content" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <a class="text-muted" data-toggle="collapse" data-target="#docs">Show/Hide Documentation</a>
          </div>
          <div class="panel-body collapse" id="docs">
            <div class="form">
              <div>
                  <dl>
                      <dt>IMAGE_BUTTON_[<em>BUTTON NAME HERE</em>]</dt>
                      <dd>
                          <p>Sample key: <em v-html="'{{IMAGE_BUTTON_CONTINUE}}'" /></p>
                          <p>Generate an button that is the same as the buttons used in different pages in the site.
                             Change the CONTINUE part to a different name like SUBMIT, CONTINUE or BACK.
                          </p>
                          <p>For image button references, please check this url:
                             <a href="/includes/languages/english/images/buttons/">/includes/languages/english/images/buttons/</a>
                             To use a image button listed in the given link, use the filename in upper case format
                             excluding the extension name (.gif, .jpg, etc...)
                          </p>
                          <p>NOTE: All keys that have no equivalent image button are ignored.</p>
                      </dd>
                  </dl>
                  <dl>
                      <dt>DEFINED_[<em>CONFIGURATION KEYS HERE</em>]</dt>
                      <dd>
                          <p>Sample key: <em v-html="'{{DEFINED_STORE_NAME}}'" /></p>
                          <p>Replaced with information that is configurable in the Admin's Configuration section.
                             All configurations have their keys which can be used to generate information that is
                             already configured.  For any configurations, the keys can be viewed at the information
                             box which is at the right side of each configuration. For example, to show the email
                             address just add <span v-html="'{{DEFINED_STORE_OWNER_EMAIL_ADDRESS}}'" /> and it will be replaced with
                             whatever the value is in the configuration.
                          </p>
                          <p>NOTE: All keys that do not exist in the configuration are ignored.</p>
                      </dd>
                  </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import { upperFirst } from '@/plugin/filter/string'
import { format as dateFormat } from '@/plugin/filter/date'
import uuid from 'uuid'
import ApiResponse from '@/plugin/mixin/api-response'

export default{
  computed: {
    ...mapGetters('page/pages', {
        layout: 'layout',
    }),
    ...mapState('page/page', {
        disable: 'disable',
        form: 'form',
        list: 'list',
    }),
    ...mapGetters('page/page', {
        requestingServer: 'requestingServer',
    }),
    isNewPage() {
      return 'admin/cms/v3/page/new' === this.$route.name
    },
    targetPageSlug() {
      return this.$route.params.name
    },
    fetchingData() {
      return this.requestingServer
    },
    isStorageDatabase() {
      return 'database' === this.form.storage
    },
    isStorageFile() {
      return 'file' === this.form.storage
    }
  },
  watch:{
    name() {
      this.$store.dispatch('page/page/clear')
    },
    '$route.name'() {
      if (!this.isNewPage) {
        return
      }
      this.$store.dispatch('page/page/startNew', uuid())
    }
  },
  created() {
    if (this.isNewPage) {
      this.$store.dispatch('page/page/startNew', uuid())
    } else {
      this.fetch()
    }
  },
  methods: {
    fetch() {
      this.$store.dispatch('page/page/fetch', this.targetPageSlug)
    },
    async save() {
      if (!this.validate()) {
        return
      }

      try {
        await this.$store.dispatch('page/page/save', this.form)

        this.$router.push({name: 'admin/cms/v3/page/view', params: {name: this.form.slug}})

        this.$alertify.success('Page saved')
      } catch (e) {
        if (this.isResponseError(e)) {
          this.raiseErrorMessage(e)
        } else {
          this.$alertify.error(`Page not saved: ${e}`)
          throw e
        }
      }

      await this.$store.dispatch('page/page/fetch', this.form.slug)
    },
    async destroy() {
      const result = confirm('Are you sure you want to delete this page?')

      if (!result) {
        return
      }

      try {
        await this.$store.dispatch('page/page/delete', this.form)

        this.$alertify.success('Page deleted')
        this.$router.push({name: 'admin/cms/v3/pages/list', params: {layout: 'table'}})
      } catch (e) {
        if (this.isResponseError(e)) {
          this.raiseErrorMessage(e)
        } else {
          this.$alertify.error(`Page not deleted: ${e}`)
          throw e
        }
      }
    },
    async create() {
      this.$router.push({
        name: 'admin/cms/v3/page/new',
        query: _.assign({}, this.$route.query)
      })
    },
    cancel() {
      this.$router.push({
        name: 'admin/cms/v3/pages/list',
        params: {
          layout: _.get(this.$route, 'query.layout', 'table')
        }
      })
    },
    validate(){
      let validate = true

      const requiredField = [
        'slug',
        'title',
        'datePosted',
      ]

      const self = this

      _.forOwn(this.form, function(value, field) {
        if (_.includes(requiredField, field) && !value) {
          self.$alertify.error(`Fill up ${field}`)
          validate = false
        }
      })

      return validate
    }
  },
  filters: {
    upperFirst,
    dateFormat
  },
  mixins: [
    ApiResponse
  ]
}
</script>
